import { styled, css, Box, BoxProps, CircularProgress } from '@mui/material'
import { MessageStylesProps } from './Message.types'
import Heading from '../Heading'
import Text from '../Text'
import Logo from '../Logo'
import Button from '../Button'
import { getUnitValue } from '../../../utils/processStyles'

export const MessageWrapper = styled(Box, {
  shouldForwardProp: (prop) => !['buttonsHorizontal'].includes(String(prop))
})<BoxProps & MessageStylesProps>(
  ({ padding, gap }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    width: 100%;
    height: 100%;
    padding: ${getUnitValue(padding)};
    gap: ${getUnitValue(gap)};
  `
)
MessageWrapper.defaultProps = {
  padding: 24,
  gap: 12
}

export const MessageIcon = styled(Box)(
  () => css`
    height: 1em;
    width: 1em;
    margin-bottom: 8px;
  `
)
MessageIcon.defaultProps = {
  fontSize: 64
}

export const MessageImage = styled(Logo)(
  () => css`
    margin-bottom: 12px;
  `
)
MessageImage.defaultProps = {
  size: 64
}

export const MessageLoader = styled(CircularProgress)(
  () => css`
    margin-bottom: 16px;
  `
)
MessageLoader.defaultProps = {
  color: 'primary',
  size: 48
}

export const MessageTitle = styled(Heading)(
  () => css`
    text-align: center;
  `
)

export const MessageText = styled(Text)(() => css``)
MessageText.defaultProps = {
  align: 'center'
}

export const MessageEndContent = styled(Box)<BoxProps & MessageStylesProps>(
  ({ theme, gap }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 100%;
    align-items: center;
    padding: 0;
    padding-top: ${getUnitValue(gap)};
    gap: ${getUnitValue(gap)};
    border-top: 1px solid ${theme.palette.grey[300]};
  `
)
MessageEndContent.defaultProps = {
  gap: 16
}

export const MessageEndTitle = styled(Heading)(
  () => css`
    text-align: center;
    font-size: 13px;
  `
)
MessageEndTitle.defaultProps = {
  variant: 'h2'
}

export const MessageEndText = styled(Text)(
  () => css`
    font-size: 12px;
  `
)
MessageEndText.defaultProps = {
  align: 'center'
}

export const MessageButtonsContent = styled(Box, {
  shouldForwardProp: (prop) => !['buttonsHorizontal'].includes(String(prop))
})<BoxProps & MessageStylesProps>(
  ({ buttonsHorizontal }) => css`
    display: flex;
    flex-direction: ${buttonsHorizontal ? 'row-reverse' : 'column'};
    align-items: center;
    width: 100%;
    padding: 0;
    gap: 8px;
    margin-top: 12px;

    button {
      flex: 1;
    }
  `
)

export const MessageButton = styled(Button)(() => css``)
